import { Fragment, h } from 'preact'; /** @jsx h */
import { useEffect, useRef, useState } from 'preact/hooks';
import { Form, MultipleStepHandler } from './FormWrappers';
import {
    ContactStep,
    FormInfo,
    LoginStep,
    PaymentStep,
    PersonInfoStep,
    SkipLogin,
    SumStep,
    UserInfo
} from './GeneralFormContent';
import { getPerson, getUserFromPhoneNumber } from './apiFunctions';
import { Events, formName } from './events';
import { CheckBox, Email } from './inputModules';
import {
    findInSession,
    getInitFormData,
    setInSession,
    standardGiftSums,
    updateFormData,
    updateFormDataWithPhoneNo
} from './variables';

const nextStepText = 'Gå videre';
const submitButtonText = 'Gå til betaling';
const giftValueSessionKey = 'sufsinglegiftvalue';

const { paymentInfo, paymentError, user } = window.NLA;
const isLoggedIn = user != null;
const initData = getInitFormData(paymentInfo);
let events;

const GiftForm = ({
    id,
    renderCb,
    kamp,
    titleStep1,
    level,
    blockCode,
    options,
    phoneNo,
    infoTxtStep1
}) => {
    const [formData, setFormData] = useState(initData);
    const [isAnonymous, setAnonymous] = useState(false);
    const [shouldLogin, setShouldLogin] = useState(false);
    const [loginCode, setLoginCode] = useState('');
    const [ignoredLogin, setIgnoredLogin] = useState({ phone: '', ignored: false });
    const [hasPhoneQuery, setHasPhoneQuery] = useState(false);
    const [monVal, setMonVal] = useState(true);

    const formUrl = `${window.location.pathname}${window.location.search || ''}#${id}`;
    const giftValueFormKey = giftValueSessionKey + id;

    useEffect(() => {
        renderCb(id);

        options = options || standardGiftSums;

        const flatOptions = options.flat();

        const optionList = [
            ...flatOptions,
            { value: ' ', label: 'eller skriv valgfritt beløp', isDefault: false }
        ];

        let newData = { ...formData, optionList };

        const defaultSum = newData.optionList.find(o => o.isDefault);

        newData.giftValue = defaultSum ? defaultSum.value : 200;

        const sessionSum = findInSession(giftValueFormKey);
        if (sessionSum) newData.giftValue = sessionSum;

        if (phoneNo && phoneNo.length > 1 && !isLoggedIn) {
            const noSpacePhoneNumber = phoneNo.replace(/\s/g, '');
            const validPhone = /^\+?\d{8,12}$/.test(noSpacePhoneNumber);
            if (validPhone) {
                getPerson({ mobilnr: noSpacePhoneNumber }).then(response => {
                    if (Object.keys(response).length > 1 && response.fornavn) {
                        newData = { ...newData, response };
                        updateFormDataWithPhoneNo(response, newData, setFormData);
                        setHasPhoneQuery(true);
                    } else setFormData(newData);
                });
            } else setFormData(newData);
        } else {
            setFormData(newData);
        }

        events = new Events(formName.gift, kamp, blockCode);

        events.startEvent();
    }, []);

    const formRef = useRef(null);

    const changeFormData = (inval, e) => {
        if (e.target.value || e.target.value === '') {
            const newObj = { ...formData };
            newObj[inval] = e.target.value;
            setFormData(newObj);
            events.changeEvent(inval);
        }
    };
    const changeRadio = (optField, newVal) => {
        if (newVal) {
            const newObj = { ...formData };
            newObj[optField] = newVal;
            setFormData(newObj);
        }
    };
    const changeData = response => {
        updateFormData(response, formData, setFormData);
    };
    const changeSelect = event => {
        if (event.target && event.target.value) {
            setFormData({ ...formData, giftValue: event.target.value });
            setMonVal(true);
            setInSession(giftValueFormKey, event.target.value);
        }
    };
    const checkPhoneNumber = () => {
        return getUserFromPhoneNumber(
            formData.phoneNumber,
            ignoredLogin,
            setIgnoredLogin,
            setShouldLogin,
            changeData,
            result => events.phoneLookUpEvent(result)
        );
    };

    const doWork = e => {
        setAnonymous(e.target.checked);
    };

    const skipLoginClick = () => {
        setShouldLogin(false);
        setIgnoredLogin({ phone: formData.phoneNumber, ignored: true });
        events.ignoreLoginEvent();
    };

    const pages = [];

    if (isLoggedIn) {
        pages.push(
            {
                name: 'loggedInInfo',
                content: (
                    <Fragment>
                        <SumStep
                            titleStep1={titleStep1 || 'Støtt vårt arbeid nå'}
                            infoText={infoTxtStep1 || 'Bidra med en enkeltgave.'}
                            paymentError={paymentError}
                            formUrl={formUrl}
                            kamp={kamp}
                            lbl="Sum"
                            optionList={formData.optionList}
                            value={monVal ? formData.giftValue : ''}
                            setVal={changeSelect}
                            onFocus={() => setMonVal(false)}
                            id={id}
                            level={level}
                            blockCode={blockCode}
                        />
                        <UserInfo formUrl={formUrl} {...user} />
                    </Fragment>
                ),
                btnText: nextStepText
            },
            {
                name: 'loggedInPaymentInfo',
                content: (
                    <PaymentStep {...formData} setVal={changeRadio} formId={id} level={level} />
                ),
                btnTxt: submitButtonText
            }
        );
    } else if (hasPhoneQuery) {
        pages.push(
            {
                name: 'loggedInInfo',
                content: (
                    <div>
                        <SumStep
                            titleStep1={titleStep1 || 'Støtt vårt arbeid nå'}
                            infoText={infoTxtStep1 || 'Bidra med en enkeltgave.'}
                            paymentError={paymentError}
                            formUrl={formUrl}
                            kamp={kamp}
                            lbl="Sum"
                            optionList={formData.optionList}
                            value={monVal ? formData.giftValue : ''}
                            setVal={changeSelect}
                            onFocus={() => setMonVal(false)}
                            id={id}
                            level={level}
                            blockCode={blockCode}
                        />
                        <Email
                            key="subEmailField"
                            value={formData.email}
                            setVal={e => changeFormData('email', e)}
                            name="email"
                        />
                        <FormInfo
                            {...formData}
                            changeFormData={changeFormData}
                            setFormData={setFormData}
                            isDataFromLookup={false}
                            level={level}
                        />
                    </div>
                ),
                btnText: nextStepText
            },
            {
                name: 'loggedInPaymentInfo',
                content: (
                    <PaymentStep {...formData} setVal={changeRadio} formId={id} level={level} />
                ),
                btnTxt: submitButtonText
            }
        );
    } else {
        pages.push(
            {
                name: 'initInfo',
                content: (
                    <SumStep
                        titleStep1={titleStep1 || 'Støtt vårt arbeid nå'}
                        infoText={infoTxtStep1 || 'Bidra med en enkeltgave.'}
                        paymentError={paymentError}
                        formUrl={formUrl}
                        kamp={kamp}
                        lbl="Sum"
                        optionList={formData.optionList}
                        value={monVal ? formData.giftValue : ''}
                        setVal={changeSelect}
                        onFocus={() => setMonVal(false)}
                        level={level}
                        blockCode={blockCode}
                    />
                ),
                btnTxt: nextStepText
            },
            {
                name: 'contactInfo',
                content: (
                    <ContactStep
                        {...formData}
                        changeFormData={changeFormData}
                        isAnonymous={isAnonymous}
                        level={level}
                    >
                        <CheckBox
                            name="anon"
                            checked={isAnonymous}
                            label="Jeg vil være anonym"
                            onChange={e => doWork(e)}
                        />
                    </ContactStep>
                ),
                btnTxt: nextStepText,
                nextFunction: checkPhoneNumber
            }
        );

        if (shouldLogin) {
            pages.push({
                name: 'loginStep',
                content: (
                    <LoginStep
                        loginCode={loginCode}
                        setLoginCode={setLoginCode}
                        formUrl={formUrl}
                        level={level}
                        {...formData}
                    />
                ),
                btnTxt: 'Logg inn',
                alternateRoute: <SkipLogin onClick={skipLoginClick} />
            });
        } else {
            if (!isAnonymous) {
                pages.push({
                    name: 'personInfo',
                    content: (
                        <PersonInfoStep
                            {...formData}
                            changeFormData={changeFormData}
                            setFormData={setFormData}
                            isDataFromLookup={false}
                            level={level}
                        />
                    )
                });
            }

            pages.push({
                name: 'paymentInfo',
                content: (
                    <PaymentStep {...formData} setVal={changeRadio} formId={id} level={level} />
                ),
                btnTxt: submitButtonText
            });
        }
    }

    return (
        <Form
            id={id}
            tabIndex="-1"
            method="post"
            action={shouldLogin ? '/medl/login.php' : '/medl/gave2_create.php'}
            ref={formRef}
        >
            <MultipleStepHandler
                pageArr={pages}
                formRef={formRef}
                updateStepEvent={step => events.updateStepEvent(step)}
            />
        </Form>
    );
};

export default GiftForm;
